import React from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { ImmunizationSeriesEvent } from "../models/Interfaces";
import { getDateTime } from "../utils/data";

interface EventCardProps {
  event: ImmunizationSeriesEvent;
  vaccine: string;
}

export default function EventCard({ event, vaccine }: EventCardProps) {
  const { t } = useTranslation();

  const readableDate = (date: string) => {
    return getDateTime(date).toLocaleString();
  };

  return (
    <div className="card bg-base-100 max-md:mx-4">
      <div className="card-body">
        {(event.description || vaccine) && (
          <div
            role="paragraph"
            className="text-dark font-black text-lg"
            data-testid="event-card-title"
          >
            {`${event.description || vaccine}`}
          </div>
        )}
        <div className="grid grid-cols-[auto_1fr]">
          {event.dateAdministered && (
            <>
              <span className="text-primary mr-2 font-bold">
                {t("immunizations.records_event_administered")}
              </span>
              <span className="font-semibold">{readableDate(event.dateAdministered)}</span>
            </>
          )}
          {event.administeredAtFacility && (
            <>
              <span className="text-primary mr-2 font-bold">
                {t("immunizations.records_event_provider")}
              </span>
              <span className="font-semibold">{event.administeredAtFacility}</span>
            </>
          )}
          {event.manufacturer && (
            <>
              <span className="text-primary mr-2 font-bold">
                {t("immunizations.records_event_manufacturer")}
              </span>
              <span className="font-semibold">{event.manufacturer}</span>
            </>
          )}
          {event.lot && (
            <>
              <span className="text-primary mr-2 font-bold">
                {t("immunizations.records_event_lot")}
              </span>
              <span className="font-semibold">{event.lot}</span>
            </>
          )}
          {parseInt(event?.doseNumberInSeries || "0") > 0 && (
            <>
              <span className="text-primary mr-2 font-bold">
                {t("immunizations.records_event_dose_number")}
              </span>
              <span className="font-semibold">{event.doseNumberInSeries}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
